<template>
  <div class="directory__list">
    <h3>{{category.catName}}</h3>
    <ul>
      <list-item :key="marker.id" v-for="marker in category.markers" :marker="marker" :catIndex="category.index"/>
    </ul>
  </div>
</template>
<script>

import CategoryListItem from './CategoryListItem.vue'

export default {
  name: 'CategoryList',
  components : {
    'list-item' : CategoryListItem
  },
  data () {
    return {
    }
  },
  methods : {

  },
  props :['category'],
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CategoryList.vue